/** Environment-specific — do not overwrite when promoting theme to production. */
export const RESTAURANT_ID = '87e20056-d1e8-4337-9333-3063a5582e2d';

/** Guests cannot change restaurant — always this outlet. */
export const FIXED_RESTAURANT = true;

/** Used when no table is in the URL or storage (e.g. walk-in / direct link). */
export const DEFAULT_TABLE = 'N/A';
